var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" }, attrs: { id: _vm.containerId } },
    [
      _c(
        "a-upload",
        _vm._b(
          {
            class: { "uploadty-disabled": _vm.disabled },
            attrs: {
              name: "file",
              multiple: _vm.multiple,
              action: _vm.uploadAction,
              headers: _vm.headers,
              data: { biz: _vm.bizPath },
              fileList: _vm.fileList,
              beforeUpload: _vm.doBeforeUpload,
              disabled: _vm.disabled,
              listType: _vm.complistType
            },
            on: { change: _vm.handleChange, preview: _vm.handlePreview }
          },
          "a-upload",
          _vm.fileParam,
          false
        ),
        [
          [
            _vm.isImageComp
              ? _c(
                  "div",
                  [
                    _c("a-icon", { attrs: { type: "plus" } }),
                    _c("div", { staticClass: "ant-upload-text" }, [
                      _vm._v(_vm._s(_vm.text))
                    ])
                  ],
                  1
                )
              : _vm.buttonVisible
              ? _c(
                  "a-button",
                  [
                    _c("a-icon", { attrs: { type: "upload" } }),
                    _vm._v(_vm._s(_vm.text) + "\n      ")
                  ],
                  1
                )
              : _vm._e()
          ]
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: { visible: _vm.previewVisible, footer: null },
          on: { cancel: _vm.handleCancel }
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { alt: "example", src: _vm.previewImage }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }